module.exports = __webpack_public_path__ + "static/media/arab05.43f0820e.wav";